import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'primepaymentflow' */ './PrimePaymentFlow'),
  loading: () => null,
  // timeout: 50000,
});

export default class PrimePaymentFlowLoader extends React.Component {
  constructor() {
    super();
    this.state = {
      //load: false,
    };
  }

  // startPaymentFlow = (event, data) => {
  //   console.log(event);
  //   console.log(data);
  //   this.setState({ load: true });
  // };

  componentDidMount() {
    //window.addEventListener('prime_paymentflow_start', this.startPaymentFlow);
  }

  componentWillUnmount() {
    // window.removeEventListener(
    //   'prime_paymentflow_start',
    //   this.startPaymentFlow,
    // );
  }

  render() {
    // if (!this.state.load) {
    //   return null;
    // }
    return <LoadableComponent {...this.props} />;
  }
}
